export default "/cyrillic.b63651df-d71650.woff2";